import { render, staticRenderFns } from "./themegj.vue?vue&type=template&id=2fb2bc05&"
import script from "./themegj.vue?vue&type=script&lang=js&"
export * from "./themegj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports